import { ComponentType } from 'react';
import { StepComponents } from '../../config/stepComponents';
import { StepObject } from '../../types';

type GetStepComponentProps = {
  steps: StepObject[];
  currentStepIndex: number;
};
export const getCurrentStepComponent = ({
  steps,
  currentStepIndex,
}: GetStepComponentProps): ComponentType | null => {
  if (currentStepIndex < 0) return null;

  const step = steps[currentStepIndex];

  if (!step) return null;

  const StepComponent = StepComponents[step.name];

  if (!StepComponent) return null;

  return StepComponent;
};
